import { render, staticRenderFns } from "./LongLinkModule.vue?vue&type=template&id=494e6f96&scoped=true"
import script from "./LongLinkModule.vue?vue&type=script&lang=js"
export * from "./LongLinkModule.vue?vue&type=script&lang=js"
import style0 from "./LongLinkModule.vue?vue&type=style&index=0&id=494e6f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e6f96",
  null
  
)

export default component.exports